import axios from "axios";
import authService from '../services/authService';

export default {
    /**
     * Create a secure request to server with bearer token
     * @return {Promise}
     */
    createHttpRequest(responseType) {        
        return new Promise((resolve, reject) => {
            authService.acquireToken().then(token => {
                resolve(
                    axios.create({
                        baseURL: process.env.VUE_APP_API_URI,
                        headers: {
                            Authorization: "Bearer " + token
                        },
                        responseType: responseType == null ? "text" : responseType
                    })
                );
            }, () => {
                reject({ message: "Unable to retrieve a valid token" });
            })
        });
    },
    // https://github.com/axios/axios#handling-errors
    async parseHttpRequestError(error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
    
            // this would use more complex error messages, but we can get these from the console, so instead we use the simpler version, below
            // return error.response.status + " error: " + error.message + " - " + JSON.stringify(error.response.data);
    
            // For auth failures return the statusText
            if (error.response.status == 401) {
                return error.response.statusText;
            }
    
            if (error.response.data) {
                let errorDetails = error.response.data;
                if(errorDetails instanceof Blob){
                    if(errorDetails.type === "application/json"){
                        let text = await errorDetails.text();
                        errorDetails = JSON.parse(text);
                    }
                }

                if (errorDetails.ExceptionMessage) {
                    return errorDetails.ExceptionMessage;
                }
                else if (errorDetails.Message) {
                    return errorDetails.Message;
                }
    
                return errorDetails;
            }
    
            return error.response;
        }
        else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            return "A request was made but no response was received from the server";
        }
        else {
            // Something happened in setting up the request that triggered an Error
    
            if (error.message) {
                return error.message;
            }
    
            // yeah, so you're not getting a string back if we get here
            // you can still print the thing and get some use out of it though, which is really the point
            return error;
        }
    }
}